import axios from '../utils/axios';

export default function fetchCourseList(adminId,params) {
    return (
        axios.get('/admin/' + adminId +'/courses/course',  {params} )
    )
}